import { render, staticRenderFns } from "./CivitaiChip.vue?vue&type=template&id=4229d10b"
import script from "./CivitaiChip.vue?vue&type=script&lang=ts"
export * from "./CivitaiChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports